
import { defineComponent, PropType, inject} from "vue";
import { AdditionalService } from "@/models/Checkout";
export default defineComponent({
  props: {
    additionalServices: {
      type: Object as PropType<AdditionalService[]>,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  setup(props, context) {
    const toggle = (id): void => {
      context.emit("toggle", id);
    };
    
    return {
      toggle
    };
  },
  data() {
    return{
      showPricesAsB2b:false, hidePrices:false
    }
  },
  mounted() {
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
    }
});
